
/**
 * Setup the document options
 */
export enum DocumentName {
  australian_passport,
  foreign_passport_aus_resident,
  foreign_passport_foreign_resident,
  australian_driver_licence,
  proof_of_age_card,
  photo_card,
  full_birth_certificate,
  citizenship_certificate,
  medicare_card,
  centrelink_card,
  dva_card,
  australian_boat_licence,
  australian_firearms_licence,
  private_security_licence,
  australian_workcover_licence,
  australian_or_foreign_driver_licence,
  foreign_government_issued_identity,
  other_supporting_document
}
export const DocumentNameToDisplay = {
  [DocumentName.australian_passport]: 'Australian passport',
  [DocumentName.foreign_passport_aus_resident]:'Foreign passport' ,
  [DocumentName.foreign_passport_foreign_resident]:'Foreign passport' ,
  [DocumentName.australian_driver_licence]: 'Australian driver licence',
  [DocumentName.proof_of_age_card]: 'Proof of age card (issued by the Commonwealth, a state or territory)',
  [DocumentName.photo_card]: 'Photo card (issued by the Commonwealth, a state or territory)',
  [DocumentName.full_birth_certificate]:'Full birth certificate' ,
  [DocumentName.citizenship_certificate]:'Citizenship certificate',
  [DocumentName.medicare_card]: 'Medicare card',
  [DocumentName.centrelink_card]: 'Centrelink card',
  [DocumentName.dva_card]: 'DVA card',
  [DocumentName.australian_boat_licence]: 'Australian boat licence (with photo)',
  [DocumentName.australian_firearms_licence]: 'Australian firearms licence (with photo)',
  [DocumentName.private_security_licence]: 'Private security licence (with photo)',
  [DocumentName.australian_workcover_licence]: 'Australian WorkCover licence (with photo)',
  [DocumentName.australian_or_foreign_driver_licence]: 'Australian / foreign driver licence',
  [DocumentName.foreign_government_issued_identity]: 'Foreign government issued identity',
  [DocumentName.other_supporting_document]: 'Other supporting document'
}

/**
 * Setup category options
 */
export enum CategoryName {
  category_1,
  category_2,
  category_3,
  category_4a,
  category_4b,
  category_6a,
  category_6b,
}
export const CategoryNameToDisplay = {
  [CategoryName.category_1]: "Category 1",
  [CategoryName.category_2]: "Category 2",
  [CategoryName.category_3]: "Category 3",
  [CategoryName.category_4a]: "Category 4(a)",
  [CategoryName.category_4b]: "Category 4(b)",
  [CategoryName.category_6a]: "Category 6(a)",
  [CategoryName.category_6b]: "Category 6(b)",
}

/**
 * Link Category options to document options
 */
type DocumentSightingCategorySubSection = {
  documentNames: DocumentName[];
}
type DocumentSightingCategory = {
  categoryName: CategoryName,
  subSections: DocumentSightingCategorySubSection[]
}

export const documentSightingCategories: DocumentSightingCategory[] = [
  {
    categoryName: CategoryName.category_1,
    subSections: [
      {
        documentNames: [
          DocumentName.australian_passport,
          DocumentName.foreign_passport_aus_resident
        ]
      },
      {
        documentNames: [
          DocumentName.australian_driver_licence,
          DocumentName.proof_of_age_card,
          DocumentName.photo_card,
        ]
      }
    ]
  },
  {
    categoryName: CategoryName.category_2,
    subSections: [
      {
        documentNames: [
          DocumentName.australian_passport,
          DocumentName.foreign_passport_aus_resident
        ]
      },
      {
        documentNames: [
          DocumentName.full_birth_certificate,
          DocumentName.citizenship_certificate,
        ]
      },
      {
        documentNames: [
          DocumentName.medicare_card,
          DocumentName.centrelink_card,
          DocumentName.dva_card
        ]
      }
    ]
  },
  {
    categoryName: CategoryName.category_3,
    subSections: [
      {
        documentNames: [
          DocumentName.australian_driver_licence,
          DocumentName.proof_of_age_card,
          DocumentName.photo_card,
        ]
      },
      {
        documentNames: [
          DocumentName.full_birth_certificate,
          DocumentName.citizenship_certificate,
        ]
      },
      {
        documentNames: [
          DocumentName.medicare_card,
          DocumentName.centrelink_card,
          DocumentName.dva_card
        ]
      }
    ]
  },
  {
    categoryName: CategoryName.category_4a,
    subSections: [
      {
        documentNames: [
          DocumentName.australian_passport,
          DocumentName.foreign_passport_aus_resident,
        ]
      },
      {
        documentNames: [
          DocumentName.australian_boat_licence,
          DocumentName.australian_firearms_licence,
          DocumentName.private_security_licence,
          DocumentName.australian_workcover_licence
        ]
      }
    ]
  },
  {
    categoryName: CategoryName.category_4b,
    subSections: [
      {
        documentNames: [
          DocumentName.australian_passport,
          DocumentName.foreign_passport_aus_resident
        ]
      },
      {
        documentNames: [
          DocumentName.full_birth_certificate,
        ]
      },
      {
        documentNames: [
          DocumentName.medicare_card,
          DocumentName.centrelink_card,
          DocumentName.dva_card
        ]
      }
    ]
  },
  {
    categoryName: CategoryName.category_6a,
    subSections: [
      {
        documentNames: [
          DocumentName.foreign_passport_foreign_resident
        ]
      },
      {
        documentNames: [
          DocumentName.australian_or_foreign_driver_licence,
          DocumentName.proof_of_age_card,
          DocumentName.photo_card,
        ]
      },
    ]
  },
  {
    categoryName: CategoryName.category_6b,
    subSections: [
      {
        documentNames: [
          DocumentName.foreign_passport_foreign_resident
        ]
      },
      {
        documentNames: [
          DocumentName.full_birth_certificate,
        ]
      },
      {
        documentNames: [
          DocumentName.medicare_card,
          DocumentName.centrelink_card,
          DocumentName.dva_card,
          DocumentName.foreign_government_issued_identity,
        ]
      }
    ]
  },
]

/**
 * These are the only images supported by the document sighting workflow
 */
export const allowedFileExtensions = [
  'jpg',
  'jpeg',
  'gif',
  'png',
  'bmp',
  'pdf'
]
